











export default {
  name: 'game-header'

  props: ['color','game', 'type', 'logo', 'background', 'copy']

  data: ->
    styles: 'background-image': 'url("'+@background+'")'
    classes: 'theme-'+@color
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/game/GameHeader.vue